import api from "../../../services/api";

export const getInvoiceTerms = async () => {
  const response = await api.get("/invoice-terms");
  return response;
};

export const createInvoiceTerm = async (data) => {
  const response = await api.post("/invoice-terms", data);
  return response;
};

export const updateInvoiceTerm = async (id, data) => {
  const response = await api.patch(`/invoice-terms/${id}`, data);
  return response;
};

export const deleteInvoiceTerm = async (id) => {
  const response = await api.delete(`/invoice-terms/${id}`);
  return response;
};

export const toggleActive = (id, isActive) => api.patch(`/invoice-terms/${id}`, { isActive });
